export default __webpack_public_path__ + "static/media/dtsd5168-2.ed05e13d.png";